import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import './assets/fonts/fonts.css'
const app = createApp(App)
// eslint-disable-next-line vue/multi-word-component-names
app.component('Swiper', Swiper)
// eslint-disable-next-line vue/multi-word-component-names
app.component('SwiperSlide', SwiperSlide)
createApp(App).use(router).mount('#app')